import React from 'react';
import LocationTemplate from './LocationTemplate';

const PlymouthPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Plymouth"
      stateName="North Carolina"
      countyName="Washington"
      zipCodes={["27962"]}
      latitude={35.8668}
      longitude={-76.7488}
      population={3598}
      historicalFact="Founded in 1787 on the Roanoke River; site of significant Civil War naval battle in 1864."
      nearbyTowns={[
        "Washington, NC",
        "Williamston, NC",
        "Columbia, NC",
        "Creswell, NC",
        "Jamesville, NC",
        "Windsor, NC",
        "Edenton, NC",
        "Elizabeth City, NC"
      ]}
    />
  );
};

export default PlymouthPage;